import type { AuthenticatedUserType } from "./auth-types";
import { Aggregator } from "./config";
import type { Error } from "./error-types";
import { TposMode } from "./mode";
import { LineOptions } from "./option";
import { HeroItem, MenuItem, Product } from "./product";

export type AuthenticationStateType = {
  authenticating: boolean;
  authenticatedUserData?: Omit<AuthenticatedUserType, "rememberToken">;
  loginUserError?: Error;
  isFcmTokenUpdated: boolean;
  registerUserError?: Error;
  forgotPasswordEmailSent: boolean;
  forgotPasswordError?: Error;
  updatingUser: boolean;
  updateUserError?: Error;
  smsVerificationLoading: boolean;
  smsVerificationError?: Error;
  otpResendLoading: boolean;
  otpResendError?: Error;
  remainingOtpResendAttempts: number;
};

export type CookieStateType = {
  registerUserToken: string | null;
};

export type ProductStateType = {
  productsLoading: boolean;
  products: Product[];
};

export type MenuItemStateType = {
  productsLoading: boolean;
  products: MenuItem[];
  heroSectionList: HeroItem[];
  heroFilter: string;
};

export type OptionsStateType = {
  currentLineOptions?: LineOptions;
  lineOptions: LineOptions;
};

export type ModeStateType = {
  tposMode: TposMode;
  selectedAggregator?: Aggregator;
  printerName: string;
};
